
// routes.js
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import VerifyEmail from "layouts/authentication/verify-email";
import TwoFAForm from "layouts/authentication/two-fa";
import ForgotPassword from "layouts/authentication/forget-password";
import ResetPassword from "layouts/authentication/reset-password";
import Demo from "layouts/strategy/components/strategydemo/StrategySummaryDemo";
import Mt5Scheduler from "layouts/mt5-scheduler";




export const publicRoutes = [
  { route: "/authentication/sign-in", component: <SignIn /> },
  { route: "/authentication/sign-up", component: <SignUp /> },
  { route: "/authentication/verify-email", component: <VerifyEmail /> },
  { route: "/authentication/forget-password", component: <ForgotPassword /> },
  { route: "/authentication/reset-password", component: <ResetPassword /> },
  { route: "/authentication/2fa", component: <TwoFAForm /> },
  { route: "/strategydemo", component: <Demo /> },
  { route: "/mt5-scheduler", component: <Mt5Scheduler /> },
];


